var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7A82D5D8-914E-4026-9415-D65D2E879652") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-To-Do",
    transform: "translate(-618.000000, -213.000000)",
    fill: "#838383",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history-(3)",
    transform: "translate(618.150000, 213.056587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2370458,5.5647308 C12.2373185,7.81544635 10.9027428,9.85200955 8.83899576,10.7501568 C6.77524867,11.6483041 4.37535202,11.2369915 2.7284628,9.70288707 C2.55108171,9.53877941 2.54032149,9.26194808 2.70442915,9.084567 C2.86853682,8.90718591 3.14536815,8.89642569 3.32274923,9.06053335 C4.97221216,10.5971265 7.47097779,10.7725933 9.31899786,9.48159819 C11.1670179,8.19060308 11.8620142,5.78402906 10.9867694,3.70658033 C10.1115247,1.62913161 7.90392404,0.445443454 5.68922485,0.866102465 C3.47452565,1.28676148 1.85466684,3.19743563 1.80207512,5.45111721 L2.4575381,5.45111721 C2.61427448,5.45049496 2.75933905,5.5338654 2.83770663,5.66960487 C2.91576475,5.80480551 2.91576475,5.97137956 2.83770663,6.10658019 L1.82829364,7.85448147 C1.75070377,7.99139041 1.6054917,8.07600536 1.44812511,8.07600536 C1.29075852,8.07600536 1.14554645,7.99139041 1.06795658,7.85448147 L0.058543592,6.10658019 C-0.0195145307,5.97137956 -0.0195145307,5.80480551 0.058543592,5.66960487 C0.136911168,5.5338654 0.281975733,5.45049496 0.43871212,5.45111721 L0.932494232,5.45111721 C1.0427479,2.38731318 3.57449073,-0.0305191682 6.64012309,0.000291207219 C9.70575545,0.0311015827 12.1883921,2.4993297 12.2370458,5.5647308 L12.2370458,5.5647308 Z M8.64510863,8.02053209 C8.79383618,7.83203408 8.76261486,7.55884753 8.57519257,7.40876665 L6.5563666,5.79195796 L6.5563666,2.06892824 C6.5563666,1.82759343 6.36072608,1.63195292 6.11939128,1.63195292 C5.87805647,1.63195292 5.68241596,1.82759343 5.68241596,2.06892824 L5.68241596,6.00170612 C5.68302893,6.13466546 5.74414422,6.26011261 5.84846658,6.34254686 L8.03334318,8.09044814 C8.1102243,8.15213184 8.20570187,8.18601097 8.30426788,8.18658271 C8.43722722,8.18596974 8.56267437,8.12485446 8.64510863,8.02053209 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryGray);
export default __webpack_public_path__ + "static/media/history-gray.aed646224a9e323bc84bac3f980638c9.svg";
export { ForwardRef as ReactComponent };